import { motion } from 'framer-motion';
import type { AnchorHTMLAttributes } from 'react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

import { useSubHeaderContext } from './sub-header.comp';

interface ItemProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  link: string;
  to: string;
  name: string;
}
export const SubheaderItem = ({ link, to, name, ...rest }: ItemProps) => {
  const { repositionHighlight, activeNavItem, handleNavItemClick } =
    useSubHeaderContext();

  return (
    <div className="relative py-[6px]" key={name}>
      <NavLink
        className={({ isActive }) =>
          cn([
            'relative py-2 font-normal text-[14px] transition-all',
            isActive ? 'border-b-2 border-solid text-gray-900' : 'text-gray-500'
          ])
        }
        onClick={() => handleNavItemClick(link)}
        onMouseOver={ev => repositionHighlight(ev, true)}
        to={to}
        {...rest}
      >
        <div className="rounded-md px-3 py-1 transition-all hover:text-gray-800 group-[.active]:bg-gray-300 group-[.active]:text-gray-900">
          {name}
        </div>
      </NavLink>
      {activeNavItem === link && (
        <motion.div
          className="absolute right-0 bottom-0 left-0 h-[2px] bg-gray-700"
          layoutId="underline"
        />
      )}
    </div>
  );
};
